module.exports = __webpack_public_path__ + "img/4.ef032a42.png";